import React, { Component } from 'react'

class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  componentDidCatch(error) {
    this.setState({ hasError: true, error })
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-gray-100">
          <div className="bg-white rounded-xl shadow p-6 max-w-md w-full text-center">
            <h1 className="text-xl font-semibold mb-2">Se produjo un error</h1>
            <p className="text-gray-600 mb-4">Intenta recargar la página o volver al inicio.</p>
            <a href="/" className="btn-primary">Ir al inicio</a>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}

export default ErrorBoundary
